const configs = {
  test: require('./voiceGateway.test'),
  online: require('./voiceGateway.online'),
}

function resolveVoiceGatewayEnv() {
  if (typeof location === 'undefined' || !location.hostname) return 'test'
  const host = location.hostname
  if (host === 'localhost' || host === '127.0.0.1') return 'test'
  if (host === 'tbig-model-debug.gooki.com') return 'test'
  if (/\.bj\.gooki\.com$/.test(host)) return 'test'
  if (host.indexOf('test.') === 0 || host.indexOf('.test.') >= 0) return 'test'
  return 'online'
}

module.exports = configs[resolveVoiceGatewayEnv()] || configs.test
